import { useSyncExternalStore } from 'react';
import { useTranslation } from 'react-i18next';
const noSubscribe = () => () => { };
/**
 * `AppTopBar`'s `fullscreen` prop for a control, or `undefined` without one, so
 * every Top Bar (Lobby, Block Jam, Water Sort) offers the same toggle the same
 * way. Live: the player can also leave full screen with the system gesture.
 * `onTap` lets a game add its own button sound.
 */
export function useFullscreenToggle(control, onTap) {
    const { t } = useTranslation();
    const active = useSyncExternalStore(control?.subscribe ?? noSubscribe, () => control?.isActive() ?? false);
    if (!control)
        return undefined;
    return {
        active,
        onToggle: () => {
            onTap?.();
            void control.toggle();
        },
        ariaLabel: t(active ? 'layout.exitFullscreen' : 'layout.enterFullscreen'),
    };
}
